import script from "./NewsLetter-item.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsLetter-item.vue?vue&type=script&setup=true&lang=js"

import "./NewsLetter-item.vue?vue&type=style&index=0&id=21258f66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21258f66"]])

export default __exports__